<template>
  <b-form-group :label="label"
                :invalid-feedback="errorTxt"
                :state="state">
    <b-input-group :prepend="$t('target')">
      <b-form-select v-model="targetType" :options="targetTypes" @change="load" :state="state"></b-form-select>
      <v-select v-if="targetType!=='externalNumber'" v-model="inputVal"
                label="text" :reduce="tar => tar.value"
                :options="targetValues" :disabled="!targetType" :state="state">
      </v-select>
      <b-form-input v-if="targetType==='externalNumber'" :placeholder="$t('enterNumber')" v-model="inputVal"></b-form-input>
    </b-input-group>
  </b-form-group>
</template>

<script>
export default {
  props: ['model', 'label', 'errors', 'disabled', 'attribute'],
  data() {
    return {
      inputVal: this.model[this.attribute] ? this.model[this.attribute] : null,
      targetType: null,
      state: null,
      errorTxt: '',
      targetTypes: [
        {value: null, text: this.$t('selectTarget')},
        {value: 'ivr', text: this.$t('ivr')},
        {value: 'group', text: this.$t('group')},
        {value: 'ext', text: this.$t('ext')},
        {value: 'queue', text: this.$t('queue')},
        {value: 'timeCondition', text: this.$t('timeCondition')},
        {value: 'announcement', text: this.$t('announcement')},
        {value: 'apiRoute', text: this.$t('apiRoute')},
        {value: 'externalNumber', text: this.$t('externalNumber')},
      ],
      targetValues: [
        {value: null, text: this.$t('selectTarget')},
      ],
    }
  },
  watch: {
    model: {
      handler(val) {
        this.state = null;
        this.errorTxt = '';
        this.inputVal = val[this.attribute] ? val[this.attribute] : null;
      }, deep: true
    },
    inputVal(val) {
      this.state = null;
      this.errorTxt = '';
      this.model[this.attribute] = val;
    },
    errors(val) {
      let hasErr = false;
      if (val.length) {
        val.forEach(v => {
          if (v.param === this.attribute) {
            this.state = false;
            this.errorTxt = v.msg;
            hasErr = true;
          }
        });
      }
      this.state = !hasErr;
    }
  },
  methods: {
    load() {
      if (this.targetType === 'externalNumber') {
        return;
      }
      let url = null;
      if (this.targetType === 'ivr') {
        url = '/ivr';
      }
      if (this.targetType === 'group') {
        url = '/user-group';
      }
      if (this.targetType === 'ext') {
        url = '/user';
      }
      if (this.targetType === 'queue') {
        url = '/queue';
      }
      if (this.targetType === 'timeCondition') {
        url = '/time-condition';
      }
      if (this.targetType === 'apiRoute') {
        url = '/api-route';
      }
      if (this.targetType === 'announcement') {
        url = '/announcement';
      }
      if (url == null) {
        this.inputVal = null;
        return;
      }
      this.targetValues = [
        {value: null, text: this.$t('selectTarget')}
      ];
      this.$bgService.get(url, {
        params: {
          page: 1,
          pageSize: 1500,
          status: 0
        }
      }).then(response => {
        let found = false;
        response.data.docs.forEach(item => {
          this.targetValues.push({value: item.ext, text: item.ext + ' (' + item.name + ')'});
          if (item.ext === this.model[this.attribute]) {
            found = true;
          }
        });
        if (!found) {
          this.inputVal = null;
        }
      });
    }
  },
  mounted() {
    if (this.model[this.attribute]) {
      if (/^1[0-9]{2}$/.test(this.model[this.attribute])) {
        this.targetType = 'ivr';
      }
      if (/^2[0-9]{2}$/.test(this.model[this.attribute])) {
        this.targetType = 'queue';
      }
      if (/^3[0-9]{2}$/.test(this.model[this.attribute])) {
        this.targetType = 'timeCondition';
      }
      if (/^4[0-9]{2}$/.test(this.model[this.attribute])) {
        this.targetType = 'announcement';
      }
      if (/^5[0-9]{2}$/.test(this.model[this.attribute])) {
        this.targetType = 'apiRoute';
      }
      if (/^[1-9][0-9]{3}$/.test(this.model[this.attribute])) {
        this.targetType = 'group';
      }
      if (/^[1-9][0-9]{4,5}$/.test(this.model[this.attribute])) {
        this.targetType = 'ext';
      }
      if (/^[0-9]{7,13}$/.test(this.model[this.attribute])) {
        this.targetType = 'externalNumber';
      }
    }
    this.load();
  }
}
</script>
